import i18n from "i18next";
import {User} from "crqlar-react-common/dist/models/identity/user.model";

// The interface language is saved on the user (MyAccountService.changeLanguage), but the
// language detector only reads localStorage/browser language. Apply the saved one on every
// login/session restore so it survives cleared storage, new devices and mobile browsers.
export const applyUserLanguage = (user?: User) => {
    const language = user?.interfaceLanguage;
    if (language && language !== i18n.resolvedLanguage) {
        void i18n.changeLanguage(language);
    }
};
